import React, { useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import PageView from "./components/Analytics/Universal/PageView/PageView";
import Form from "./components/Form/Form";
import Header from "./components/Header/Header";
import { getDomainConfig } from "./config/config";
import PageViewGlobal from "./components/Analytics/Universal/PageView/PageViewGlobal";
import { AdobeTag } from "./components/Analytics/Universal/AdobeTag/AdobeTag";
import { googleDataLayer } from "./components/Analytics/Universal/PageView/googleDataLayer";
import ExitPopUp from "./utils/exitPopUp.js";

// Initialize React Query Client.
const queryClient = new QueryClient();

function App() {

  const config = getDomainConfig();

  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);
  useEffect(() => {

    const getStyles = async (theFileName, theFileEnd) => {
      if (config.brand) {
        let moduleStyles = false;
        try {
          moduleStyles = await import(
          "./" + theFileName + config.brand + theFileEnd
              );
          setStyles(moduleStyles);
        } catch (e) {
          console.error(
              `Styles for ${theFileName} could not be loaded, ${e.message}`
          );
        }
      }
    };

    // Specify file name and end of file name here.
    getStyles("App", ".scss");
  }, [config.brand]);

  /* END LOADING THE BRANDED SCSS */


  useEffect(() => {
    document.title = "Secure Checkout | " + config.siteName;
    // Function responsible for adding AdobeTag script to HEAD of the document.
    // Previously in PageView component, unfortunately was causing issue (CHEC-174 Jira ticket) where was rendered 5 times (amount of times PageView component is rendered in the app).
    if (config.siteName === 'Universal Bookings') {
      const scriptTag = document.createElement("script");
      scriptTag.setAttribute('src', AdobeTag());
      scriptTag.setAttribute('async', 'async');

      document.head.appendChild(scriptTag);
      }

    googleDataLayer.createPageEvent()
  }, [config.siteName]);

  const favicon = document.getElementById("favicon");
  favicon.href = config.favicon;

  return (
    <QueryClientProvider client={queryClient}>
        <Header/>
        <Form/>
        {config.siteName === "Universal Bookings" ? (
        <PageView />
      ) : (
        <PageViewGlobal />
      )}
      </QueryClientProvider>
    );
}

ExitPopUp.Enable();

export default App;
